export const auctionDateInfoStyle = {
	wrapper: {
		width: '100%',
		height: '76px',
		display: 'flex',
		overflow: 'inherit',
		borderRadius: '8px',
		background: 'var(--default-white)',
		boxShadow: 'var(--box-shadow--1)',
		padding: '16px',
		marginBottom: '16px',
		justifyContent: 'space-between',
	},

	content: {
		display: 'flex',
		gap: '12px',
		alignItems: 'center',
	},

	disabled: {
		color: 'var(--neutral-300)',
	},

	date: {
		display: 'flex',
		gap: '4px',
		alignItems: 'center',
	},

	dateItem: {
		display: 'flex',
		gap: '4px',
		alignItems: 'center',
	},

	title: {
		textTransform: 'capitalize',
	},

	icon: {
		svg: {
			width: '22px',
			height: '22px',
		},

		'& svg path': {
			fill: 'var(--neutral-200)',
		},
	},
};
